import React, { useState } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { FloatingDialogModal, OpenSeaDragon } from '../index';
import { GallerySection, GalleryContainer, GalleryFigure, GalleryPrevNext, GalleryButton, GalleryModalContainer } from './Gallery.style';
import { IGalleryProps } from './Gallery.i';
import { useOverlayTriggerState } from '@react-stately/overlays';
import { OverlayContainer } from '@react-aria/overlays';

export const Gallery = ({ items, minHeight }: IGalleryProps) => {
  const [from, setFrom] = useState(0);
  const [current, setCurrent] = useState(0);
  const overlayState = useOverlayTriggerState({});
  const openModal = (i: number) => {
    setCurrent(i);
    overlayState.open();
  };

  // NEED TO FIGURE OUT HOW TO POSITION "OPEN FULLSCREEN" BUTTON IN A BETTER WAY

  return (
    <GallerySection>
      <GalleryPrevNext
        aria-label='Previous Page'
        aria-hidden={from <= 0 || overlayState.isOpen}
        onPress={() => setFrom(from - 15)}
      ><FaChevronLeft/></GalleryPrevNext>
      <GalleryContainer minHeight={minHeight}>
        {items && items.map((item, i) => i >= from && i < (from + 15) ? (
          <GalleryFigure key={i}>
            <GalleryButton onPress={() => openModal(i)} aria-label='Show full size'>
              <img src={item.ThumbnailURL} alt='' />
            </GalleryButton>
          </GalleryFigure>
        ) : (<React.Fragment key={i}/>))}
      </GalleryContainer>

      <GalleryPrevNext
        aria-label='Next Page'
        aria-hidden={!items || items.length - from <= 15 || overlayState.isOpen}
        onPress={() => setFrom(from + 15)}
      ><FaChevronRight/></GalleryPrevNext>
      {overlayState.isOpen
        && <OverlayContainer>
          <FloatingDialogModal
            isOpen
            showCloseButton
            isDismissable
            onClose={() => overlayState.close()}
          >
            {items && items[current]
              && <GalleryModalContainer>
                <OpenSeaDragon
                  photo={items[current].ImageURL}
                  bg={false}
                  navPrev={current > 0 && (() => {
                    current > 0 && setCurrent(current -1);
                  })}
                  navNext={current < items.length -1 && (() => {
                    current < items.length -1 && setCurrent(current + 1);
                  })}
                  fullscreen
                  showNavOutsideFullscreen
                />
              </GalleryModalContainer>
            }
          </FloatingDialogModal>
        </OverlayContainer>
      }
    </GallerySection>
  );
};
